import { isBusinessEmail, validateEmail } from '../../../../../utils/generalHelpers';
import { setPersonalEmailWarningModal } from '../../../../../store/signUp/slice';
import VerificationStep from '../../components/VerificationStep';
import { EditSquareIcon, CheckSolidIcon } from '../../../../../assets/icons';
import { useCredentialReset } from '../../hooks/useCredentialReset';
import { selectProfile } from '../../../../../store/workspace/selectors';
import { setEditEmailModal } from '../../../../../store/workspace/slice';
import { useDispatch, useSelector } from '../../../../../store/store';
import styles from './style.module.scss';
import Modal from '../../../../../components/Modal';
import Input from '../../../../../components/Input';
import { useState } from 'react';

export default function EditEmail() {
    const dispatch = useDispatch();
    const profile = useSelector(selectProfile);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [emailErrorMessage, setEmailErrorMessage] = useState('');
    const [passwordErrorMessage, setPasswordErrorMessage] = useState('');

    const {
        otp,
        step,
        setOtp,
        setStep,
        isLoading,
        requestCode,
        confirmCode,
        responseError,
    } = useCredentialReset(() => profile && ({
        key: password,
        newEmail: email,
        email: profile.email,
    }));

    const closeModal = () => dispatch(setEditEmailModal(false));

    const submit = () => {
        if (!profile) return;

        if (step === 'Done') {
            closeModal();
            return;
        }

        if (step === 'Confirm') {
            confirmCode();
            return;
        }

        if (!isBusinessEmail(email)) {
            dispatch(setPersonalEmailWarningModal(true));
            return;
        }

        if (!validateEmail(email) || !password) {
            setEmailErrorMessage(validateEmail(email) ? '' : 'Invalid email');
            setPasswordErrorMessage(password ? '' : 'Password is required');
            return;
        }

        requestCode();
    };

    return (
        <Modal
            size='sm'
            actions='both'
            title='Edit email'
            closeFunc={closeModal}
            icon={<EditSquareIcon />}
            childClassName={styles.wrapper}
            dismissButton={{
                text: 'Cancel',
                type: 'Outline-Dark',
                disabled: isLoading,
                onClick: closeModal,
            }}
            confirmButton={{
                text: 'Confirm',
                type: 'Primary',
                onClick: submit,
                disabled: !profile,
                loading: isLoading,
            }}
        >
            {step === 'Request' && (
                <>
                    <Input
                        type='email'
                        value={email}
                        label='New email'
                        onChange={setEmail}
                        error={emailErrorMessage}
                    />
                    <Input
                        type='password'
                        value={password}
                        label='Current password'
                        onChange={setPassword}
                        error={passwordErrorMessage}
                    />
                </>
            )}

            {step === 'Confirm' && <VerificationStep
                otp={otp}
                target={email}
                onOtpChange={setOtp}
                changeText='Change email'
                onChangeTarget={() => setStep('Request')}
            />}

            {step === 'Done' && <div className={styles.done}>
                <CheckSolidIcon />
                <span>
                    Email updated successfully
                </span>
            </div>}

            {responseError && <span className={styles.error}>{responseError}</span>}
        </Modal>
    );
};
